<div style="margin-top: 0.5rem">
  <kendo-tabstrip #rightSideTabStrip [keepTabContent]="true">
    <kendo-tabstrip-tab title="Selections" [selected]="true">
      <ng-template kendoTabContent>
        <app-filter-selections></app-filter-selections>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="History">
      <ng-template kendoTabContent>
        <app-previous-queries></app-previous-queries>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Saved Queries">
      <ng-template kendoTabContent>
        <app-saved-filters></app-saved-filters>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>
